import React from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { setDescription } from '../../../../redux/features/support/supportEmail';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';

const EmailDescription: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch(); 

  const colors = useAppSelector(state => state.theme.colors);
  const description = useAppSelector(state => state.supportEmail.description);
  const isMobile = useMediaQuery('(max-width:600px)');

  // Dispatch the description change directly to Redux
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setDescription(e.target.value));
  };

  return (
    <Box sx={{ 
      marginTop: '3vh',
      marginBottom: '3vh',
    }}>
      <TextField
        sx={{
          width: isMobile ? '100%' : '50%',
          backgroundColor: colors?.supportEmailBackground,
          color: colors?.text,
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
        }}
        InputProps={{ 
          style: { 
            color: colors?.text,
          }
        }}
        onChange={handleChange}
        id="outlined-multiline-static"
        label={t('description')}
        placeholder={String(t('description'))}
        autoFocus
        multiline
        value={description}
        rows={4}
      />
    </Box>
  );
};

export default EmailDescription;